import styled from 'styled-components';

export const ReducedLeftPaddingUl = styled.ul`
  padding-left: 1.5rem;
`;
